//
// This file has been generated by [index-modules](https://npmjs.com/index-modules)
//

const properties = {}

import _networking, * as __networking from "./networking"
properties.networking = { enumerable: true, get: () => _networking }
export { __networking as networking }

import _patching, * as __patching from "./patching"
properties.patching = { enumerable: true, get: () => _patching }
export { __patching as patching }

import _storage, * as __storage from "./storage"
properties.storage = { enumerable: true, get: () => _storage }
export { __storage as storage }

import _vm, * as __vm from "./vm"
properties.vm = { enumerable: true, get: () => _vm }
export { __vm as vm }

export default Object.create(null, properties)
